<template>
  <div class="care-rules">
    <div class="title">ペット飼育ルール</div>
    <el-card class="rule-card" v-loading="loading">
      <!-- <div class="description">当マンションは、ペット飼育ルールについて、</div> -->

      <div class="rules-list" v-html="formattedRules"></div>

      <!-- <div class="contact">
        <div class="contact-title">お問合せ窓口</div>
        <div class="contact-phone">電話番号：xx-xxxx-xxxx</div>
      </div>

      <div class="footer">以上</div> -->
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'CareRules',
  data() {
    return {
      shiikuInfo:'',
      loading: false
    };
  },
  created() {
    this.getRules();
  },
  computed: {
    formattedRules() {
      return this.shiikuInfo.replace(/\n/g, '<br>');
    }
  },
  methods: {
    getRules() {
      this.loading = true;
      const urlManshonId = new URLSearchParams(window.location.search).get('manshonId');
      request('careRules', urlManshonId).then(res => {
          console.log(res);
        if (res.shiikuInfo) {
          this.shiikuInfo = res.shiikuInfo;
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.care-rules {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .rule-card {
    // .description {
    //   margin-bottom: 20px;
    //   line-height: 1.6;
    // }

    .rules-list {
      margin-bottom: 30px;
      white-space: pre-wrap;
      word-wrap: break-word;
      line-height: 1.6;
      padding: 10px;

      .rule-item {
        margin-bottom: 15px;
        line-height: 1.6;
      }
    }

    .contact {
      margin-bottom: 20px;
      
      .contact-title {
        font-weight: bold;
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
        margin-bottom: 10px;
      }
    }

    .footer {
      margin-top: 20px;
    }
  }
}
</style>